<div class="side-box-container">
  <div class="side-box">
    <CPF-fnol-request-side-bar *ngIf="fnolRequest" [fnolRequest]="fnolRequest"></CPF-fnol-request-side-bar>
  </div>
</div>
<main>
  <CPF-fnol-request *ngIf="fnolRequest" [fnolRequest]="fnolRequest"></CPF-fnol-request>
</main>
